import type { Currency } from '@ps/web-core-enums';
import { Translation } from '@ps/web-shared-components';
import { translatedLink } from '@ps/web-shared-ui';
import { maxNumber, minNumber, numbersOnly } from '@ps/web-shared-validators';
import React, { useCallback, useState } from 'react';
import { useForm } from 'react-final-form';
import { useSelector } from 'react-redux';

import CurrencyAmount from '@swf/components/CurrencyAmount/CurrencyAmount';
import { select } from '@swf/core/store';

import AmountCurrency from '../../../../AmountCurrency/AmountCurrency';
import CTAButton from '../../../../CTAButton/CTAButton';

import {
  TXTMOB_Max_limitX_N0,
  TXTWCL_If_you_already_have_a_Cross_Op_ELL,
  TXTWCL_Select_the_maximum_amount_you__ELL,
  TXTWCL_The_minimum_value_for_this_lim_ELL,
  TXTWCL_Whole_numbers_onlyX_No_decimal_ELL
} from './RMFCrossOperatorDepositLimitFields.messages.json';
import styles from './RMFCrossOperatorDepositLimitFields.scss';

const MAX_LIMIT_EURO_VALUE = 1000;

const RMFCrossOperatorDepositLimitFields: React.FC = () => {
  const form = useForm();
  const [isSkipped, setIsSkipped] = useState(false);
  const defaultSystemCurrency = useSelector(select.account.getLimitCurrency);
  const defaultUserCurrency = (useSelector(select.account.getDefaultCurrencyForCountry) ||
    defaultSystemCurrency) as Currency;

  const handleSubmit = useCallback(() => {
    form.change('rmf.crossOperatorLimit.skip', false);
    form.change(`userLimitsSelect.skipped`, false);
    form.submit();
  }, [form]);

  const skipLimits = useCallback(() => {
    setIsSkipped(true);
    form.change('rmf.crossOperatorLimit.skip', true);
    form.change(`userLimitsSelect.skipped`, false);
    form.submit();
  }, [form]);

  return (
    <>
      <AmountCurrency
        amountFieldName="rmf.crossOperatorLimit.limit"
        currencyFieldName="rmf.crossOperatorLimit.currency"
        defaultCurrency={defaultUserCurrency}
        includeCurrencies={[defaultUserCurrency]}
        label={TXTWCL_Select_the_maximum_amount_you__ELL}
        inputClass={styles.crossOperatorAmount}
        errorClass={styles.crossOperatorError}
        validators={[
          numbersOnly(TXTWCL_Whole_numbers_onlyX_No_decimal_ELL, true),
          minNumber(1, { ...TXTWCL_The_minimum_value_for_this_lim_ELL, values: { 0: 1 } }, true),
          maxNumber(
            1000,
            {
              ...TXTMOB_Max_limitX_N0,
              values: {
                0: (
                  <CurrencyAmount
                    value={MAX_LIMIT_EURO_VALUE * 100}
                    currency={defaultUserCurrency}
                    isZeroExponentCurrency
                  />
                )
              }
            },
            true
          )
        ]}
        normalize={false}
      />
      {!isSkipped && (
        <p data-testid="skip-cross-operator-limit">
          <Translation
            {...TXTWCL_If_you_already_have_a_Cross_Op_ELL}
            values={{ a: translatedLink({ onClick: skipLimits }) }}
          />
        </p>
      )}
      <CTAButton onClick={handleSubmit} />
    </>
  );
};

export default RMFCrossOperatorDepositLimitFields;
